module.exports = __webpack_public_path__ + "static/flags/RP-ee85a454a82892ee3d214140dbe7b848.gif";